export const FENCE_LABELS = {
  colorbond: "Colorbond",
  corromesh: "Corromesh",
  chain_wire: "Chain Wire Mesh",
  rural: "Rural Fencing",
  tubular: "Spear Top Tubular",
  slat: "Slat Fencing (Aluminium)",
  slat_panel: "Slat Panels (Aluminium)",
  pool_alu: "Pool Fencing (Aluminium)",
  fence_extension: "Fence Extensions / Extenders",
  custom_build: "Custom Build",
  palisade: "Palisade Fencing",
  welded_mesh: "Welded Mesh",
  steel_paling: "Steel Paling",
  post_rail: "Post & Rail",
  custom_gate: "Custom Gate",
  bollard: "Bollards",
  handrail: "Hand Railing",
  sporting: "Sporting Enclosure",
  armco_guardrail: "Armco Guardrail",
  other: "Other / Custom",
  labour: "Labour",
  incidental: "Incidental",
};

export const STAGE_LABELS = {
  enquiry: "New Enquiry",
  qualified: "Qualified",
  quoted: "Quoted",
  won: "Won",
  lost: "Lost",
};

export const STAGE_ORDER = ["enquiry", "qualified", "quoted", "won", "lost"];

// Workflow step number for each stage (shown as a step-badge in kanban).
// Won and Lost share step 4 (they're terminal outcomes).
export const STAGE_STEP = {
  enquiry: 1,
  qualified: 2,
  quoted: 3,
  won: 4,
  lost: 4,
};

export const STAGE_COLORS = {
  enquiry: "bg-slate-100 text-slate-700 border-slate-300",
  qualified: "bg-sky-100 text-sky-800 border-sky-300",
  quoted: "bg-amber-100 text-amber-800 border-amber-300",
  won: "bg-emerald-100 text-emerald-800 border-emerald-300",
  lost: "bg-rose-100 text-rose-800 border-rose-300",
};

export const fmtCurrency = (n) =>
  new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD", maximumFractionDigits: 0 }).format(n || 0);

export const fmtCurrencyExact = (n) =>
  new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format(n || 0);

// Date-only ISO strings (`YYYY-MM-DD`) are parsed by `new Date()` as UTC
// midnight, which for a user west of UTC shifts to the previous day. Detect
// that pattern and construct a local-midnight Date so the display day matches
// what the user typed.
const _dateOnlyRe = /^\d{4}-\d{2}-\d{2}$/;
const _toLocalDate = (s) => {
  if (typeof s === "string" && _dateOnlyRe.test(s)) {
    const [y, m, d] = s.split("-").map(Number);
    return new Date(y, m - 1, d);
  }
  return new Date(s);
};

export const fmtDate = (s) => {
  if (!s) return "—";
  try { return _toLocalDate(s).toLocaleDateString("en-AU", { day: "2-digit", month: "short", year: "numeric" }); } catch { return s; }
};

export const fmtDateTime = (s) => {
  if (!s) return "—";
  try { return _toLocalDate(s).toLocaleString("en-AU", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }); } catch { return s; }
};
